/* eslint-disable no-param-reassign */
/* eslint-disable prettier/prettier */
/* eslint-disable default-case */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSpring, animated } from 'react-spring';
import { centerContent } from '../../Constants/styles';
import Modal from '../Modal/Modal';
import ToolTipPopUp from '../ToolTipPopUp/ToolTipPopUp';
import usesideBarAnimation from "./useSideBarAnimation"
import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    Polygon4,
    Polygon5,
    Ellipse47,
    Ellipse50,
    Ellipse48,
    Polygon6,
    Group207,
    Rectangle75,
    DiamondSm,
    Info,
} from '../../Constants/assets';


// Stylings
const SideBarContainer = styled.div`
    height: 92%;
    width: 90%;
    background-color: (255, 255, 255, 0.8);
`;
const HeaderContainer = styled.div`
    height: 6%;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    display: flex;
`;
const HeaderText = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 100%;
    width: 80%;
`;
const InfoButton = styled.div`
    width: 34px;
    height: 34px;
    ${centerContent}
    :active {
        transform: translateY(1px);
    }
    align-items: center;
    background-color: ${props => (props.show ? 'rgba(0, 122, 158, 0.2)' : '')};
    border-radius: 4px;
`;
const InnerContainer = styled.div`
    width: 338px;
    height: calc(100% - 54px);
    background: ${props => props.theme.colors.white};
    display: flex;
    align-self: end;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15);
`;
const SecondLine = styled.div`
    display: flex;
    height: 20%;
    align-items: center;
`;
const EarnedValue = styled.div`
    width: 100%;
    height: 10%;
`;
const Text = styled.div`
    font-weight: normal;
    font-size: 0.9rem;
    line-height: 75%;
    color: ${props => props.theme.colors.black};
`;
const Number = styled.div`
    font-weight: bold;
    font-size: 1.5rem;
    width: 100%;
`;
const Budget = styled.div`
    width: 100%;
    height: 10%;
`;

const NumberTwo = styled.div`
    font-weight: bold;
    font-size: 24px;
    width: 100%;
`;
const GetExtraBudget = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    text-decoration-line: underline;
    line-height: 65%;
    text-decoration-line: underline;
    color: ${props => props.theme.colors.darkBlue};
    width: 100%;
    height: 5.5%;
`;
const Resources = styled.div`
    width: 75.5%;
    height: 3.5%;
    display: flex;
`;
const TextThree = styled.div`
    color: ${props => props.theme.colors.black};
    width: 39.5%;
    margin-right: 10%;
`;
const NumberFour = styled.div`
    width: 90%;
`;

const MenImages = styled.div`
    width: 10%;
    height: 3.52187833511206vh;
`;
const BuyOrReaplaceRecources = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    text-decoration-line: underline;
    line-height: 65%;
    text-decoration-line: underline;
    color: ${props => props.theme.colors.darkBlue};
    width: 100%;
    height: 13%;
    display:flex;
    align-items: flex-start:
`;
const GameLog = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    text-decoration-line: underline;
    line-height: 65%;
    text-decoration-line: underline;
    color: ${props => props.theme.colors.darkBlue};
    width: 100%;
    height: 5%;
`;
const BottomContainer = styled.div`
    border: 1px solid ${props => props.theme.colors.whiteSmoke};
    background-color: ${props => props.theme.colors.white};
    box-sizing: border-box;
    border-radius: 1rem;
    width: 100%;
`;
const Constrains = styled.div`
    display: flex;
    height: 13.5%;
    width: 100%;
`;
const BottomSpace = styled.div`
    height: 4%;
`;
const BottomText = styled.div`
    font-weight: 500;
    font-size: 1rem;
    text-decoration-line: underline;
    width: 100%;
`;
const BottomIcon = styled.div`
    width: 20%;
    display: flex;
    justify-content: center;
`;
const BottomContainerCenter = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 45%;
`;

// Modal Styling:
const LinkContainer = styled.div`
    width: max-content;
    height: fit-content;
`;
const ModalContainer = styled.div`
    position: absolute;
    z-index: 2;
`;

const OpenProjectSheet = styled.a`
    font-size: 16px;
    ${'' /* line height was descripted as 18.75px and then 19px on desktop 18 */}
    line-height: 19px;
    font-weight: 400;
    text-decoration-line: underline;
    width: 237px;
    height: 19px;
    color: ${props => props.theme.colors.darkBlue};

    p {
        margin-top: 5px;
        ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            margin-top: 0px;
        }
    `}
    }
`;
const HeaderFirst = styled.div``;
const BurgerNav = styled.div`
    position: absolute;
    border-radius: 8px;
    top: 127px;
    right: 16px;
    background: #ffffff;
    width: 192px;
    height: 220px;
    z-index: 1000;
    list-style: none;
    display: flex;
    flex-direction: column;
    display: ${props => (props.show ? 'flex' : 'none')};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
`;
const BurgerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    width: 156px;
    height: 220px;
    left: 1242px;
    top: 126px;
    div {
        color: #2b2b32;
        font-weight: normal;
        font-size: 15px;
        line-height: 40px;
        margin-left: 15px;
        cursor: pointer;
        width: max-content;
    }
`;
const BurguerListItem = styled.div`
    width: 100%;
    height: 18%;
    
`;

const TolTipContainer = styled.div``;

export default React.memo(function SideBar({
    projectId,
    data,
    sources,
    bottom,
    toggleProject,
    toggleResources,
    toggleToolTip,
    gameLogToggle,
    openStage,
    additionalBudget,
    commentAdditionalBudget,
    logSideBar,
    toggleInfo,
    toggleGameDefinitions,
    show,
    isDisabledPMTasks,
    projectScopeDisabled,
    // modalInfoButton,
    toggleTutorial,
    handleDefinitionsStage,
    isCardOpen,
    SoundPlay,
    playerStatus,
    sideLogAnimation,
    different,
    projectNeedToBeDisabled,
    animationVars,
    toggleIsAnimationNeeded,
    prevDifferent,
    currentTile,
    gameId,
    changeProject,
    toggleAdditionalBudget,
    toggleHelp
}) {
    const [additionalBudgetPopUp, setAdditionalBudgetPopUp] = useState(false);
    const [burgerStatus, setBurgerStatus] = useState(false);
    const [showResourcesToolTip, setShowResourcesToolTip] = useState(false);
    const burgerRef = useRef(null);
    const menuRef = useRef(null);
    const [counter, setCounter] = useState(0);
    const [componentMounted, setComponentMounted] = useState(false);

    const { t } = useTranslation();


    const toggleArray = {
        "toggleGameDefinitions": toggleGameDefinitions,
        "toggleInfo": toggleInfo,
        "toggleResources": toggleResources,
        "toggleTutorial": toggleTutorial,
        "changeProject": changeProject,
        "toogleHelp":toggleHelp
    }
    const handleToggles = (name) => {
        const filterToggle = Object.keys(toggleArray).filter(ele => {
            if (ele.includes(name)) toggleArray[ele](true)
            else toggleArray[ele](false);
        })
    }


    useEffect(() => {
      setComponentMounted(true); // Set to true after the first render
    }, []);

    useEffect(() => {
        /**
         * Invoke Function onClick outside of element
         */
        const closeOpenMenus = (e) => {
            if (menuRef.current && burgerStatus) { // && !menuRef.current.contains(e.target) Add this condition to make the menu stay open on click.
                setBurgerStatus(false);
            }
        }
        // Bind
        document.addEventListener("click", closeOpenMenus);
        return () => {
            // dispose
            document.removeEventListener("click", closeOpenMenus);
        };
    }, [burgerStatus]);


    return (
        <>
            <InnerContainer>
                {(isCardOpen || projectNeedToBeDisabled) && (
                    <div
                        style={{
                            position: 'absolute',
                            zIndex: '25',
                            height: '92%',
                            width: '334px',
                        }}
                    />
                )}
                <SideBarContainer>
                    <HeaderContainer>
                        <HeaderFirst>
                            <HeaderText>{t(`global_variables.projects.${projectId}.project_name`, { projectId })}</HeaderText>
                            <OpenProjectSheet
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    if (currentTile != undefined && currentTile.type === 'planned-task') {
                                        projectScopeDisabled(false);
                                        isDisabledPMTasks = false;
                                    }

                                    if (!animationVars.cameFromSideBar) {
                                        toggleIsAnimationNeeded(false, true);
                                    } else {
                                        toggleIsAnimationNeeded(false, false);
                                    }
                                    if (isDisabledPMTasks) {
                                        toggleProject(1);
                                    } else {
                                        toggleProject(openStage);
                                    }
                                }}
                            >
                                <p>{t('sidebar.project_sheet_link')}</p>
                            </OpenProjectSheet>
                        </HeaderFirst>
                        <InfoButton
                            show={burgerStatus}
                            ref={burgerRef}
                            onClick={() => setBurgerStatus(!burgerStatus)}
                        >
                            <Group207 style={{ cursor: 'pointer' }} />
                        </InfoButton>
                        <BurgerNav show={burgerStatus} ref={menuRef}>
                            <BurgerContainer>
                                <BurguerListItem
                                    onClick={() => {
                                        handleToggles("Info")
                                        // toggleInfo();
                                        handleDefinitionsStage(0);
                                    }}
                                >
                                    {t('sidebar.game_menu.game_definitions')}
                                </BurguerListItem>
                                <BurguerListItem
                                    style={{ fontSize: '15px' }}
                                    onClick={() => {
                                        // toggleGameDefinitions()
                                        handleToggles("GameDefinitions")
                                    }}
                                >
                                    {t('sidebar.game_menu.budget_and_resources')}
                                </BurguerListItem>
                                <BurguerListItem
                                    onClick={() => {
                                        // toggleInfo();
                                        handleToggles("Info")
                                        handleDefinitionsStage(1);
                                    }}
                                >
                                    {t('sidebar.game_menu.gate_control')}
                                </BurguerListItem>
                                {/* <BurguerListItem onClick={() =>
                                    // toggleTutorial()
                                    handleToggles("Tutorial")
                                }>
                                    Game Tutorial
                                </BurguerListItem> */}
                                <BurguerListItem onClick={() =>
                                    handleToggles("changeProject")
                                }>
                                    {t('sidebar.game_menu.change_project')}
                                </BurguerListItem>
                                <BurguerListItem onClick={() =>
                                    handleToggles("Help")
                                }>
                                    {t('sidebar.game_menu.help')}
                                </BurguerListItem>
                            </BurgerContainer>
                        </BurgerNav>
                    </HeaderContainer>
                    <SecondLine>
                        <Budget>
                            <Text> {t('global_variables.budget')} </Text>
                            <NumberTwo>${data.budget}</NumberTwo>
                        </Budget>
                        <EarnedValue>
                        <Text> {t('global_variables.value')} </Text>
                            <Number>
                                {data.earned}
                                <DiamondSm />
                            </Number>
                            {/* <Number>
                                <CountUp
                                    end={data.earned}
                                    duration={1}
                                    onEnd={() => console.log('Ended! EARNED👏', data.earned)}
                                    onStart={() =>
                                        console.log(
                                            'Started! EARNED💨',
                                            data.earned - needAnimation('value'),
                                        )
                                    }
                                    start={data.earned - needAnimation('value')}
                                />
                                <DiamondSm />
                            </Number> */}
                        </EarnedValue>
                    </SecondLine>
                    {!additionalBudgetPopUp && !show && (
                        <GetExtraBudget
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleAdditionalBudget(true)}
                        >
                            {t('sidebar.additional_budget_link')}
                        </GetExtraBudget>
                    )}
                    {!additionalBudgetPopUp && show && (
                        <GetExtraBudget>{t('sidebar.additional_budget_link')}</GetExtraBudget>
                    )}
                    {additionalBudgetPopUp && (
                        <GetExtraBudget>{t('sidebar.additional_budget_link')}</GetExtraBudget>
                    )}
                    <Resources>
                        <TextThree> {t('global_variables.resources.resources')} </TextThree>{' '}
                        <MenImages>
                            <WhiteSource />
                        </MenImages>
                        <NumberFour>{sources.white}</NumberFour>
                        {/* <NumberFour>
                            <CountUp
                                end={sources.white}
                                duration={2}
                                start={sources.white - needAnimation('regular')}
                            />
                        </NumberFour> */}
                            <MenImages>
                                <RedSource />
                            </MenImages>
                        <NumberFour>{sources.red}</NumberFour>
                        {/* <NumberFour>
                            <CountUp
                                end={sources.red}
                                duration={2}
                                start={sources.red - needAnimation('executive')}
                            />
                        </NumberFour> */}
                        <MenImages>
                            <GreenSource />
                        </MenImages>
                        <NumberFour
                        // className={sideLogAnimation?.resources.green ? "pulse" : ""}
                        >
                            {sources.green}
                        </NumberFour>
                        {/* <NumberFour>
                            <CountUp
                                end={sources.green}
                                duration={2}
                                start={sources.green - needAnimation('expensive')}
                            />
                        </NumberFour> */}
                        <LinkContainer>
                        <TolTipContainer
                            onMouseEnter={() => setShowResourcesToolTip(true)}
                            onMouseLeave={() => setShowResourcesToolTip(false)}
                        >
                            <Info
                                style={{
                                height: "23px",
                                width: "23px",
                                }}
                            /> 
                            <ToolTipPopUp
                                showToolTip={showResourcesToolTip}
                            />
                        </TolTipContainer>
                        </LinkContainer>
                    </Resources>
                    <br />
                    <BuyOrReaplaceRecources>
                        <LinkContainer
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleResources('Buy resources')}
                        >
                            {t('sidebar.get_resources_link')}
                        </LinkContainer>
                    </BuyOrReaplaceRecources>
                    <GameLog>
                        <LinkContainer
                            style={{ cursor: 'pointer' }}
                            onClick={() => gameLogToggle(true)}
                        >
                            {t('sidebar.game_log_link')}
                        </LinkContainer>
                    </GameLog>
                    <BottomContainerCenter>
                        <BottomContainer>
                            <BottomSpace />
                            <Constrains>
                                    <BottomIcon>
                                        <Ellipse47 className={sideLogAnimation?.plannedTask ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText>
                                    {' '}
                                    {`${logSideBar.Planned}`}/18 {t('sidebar.log_counter.planned_tasks')}
                                </BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Ellipse48 className={sideLogAnimation?.unplanned ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText>
                                    {`${logSideBar.Unplanned}`} {t('sidebar.log_counter.unplanned_tasks')}
                                </BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Polygon4 className={sideLogAnimation?.constraint ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText>
                                    {' '}
                                    {`${logSideBar.Constraint}`} {t('sidebar.log_counter.constraints')}
                                </BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Polygon6 className={sideLogAnimation?.risk ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText> {`${logSideBar.Risk}`} {t('sidebar.log_counter.risks')}</BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Rectangle75 className={sideLogAnimation?.delay ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText> {`${logSideBar.Delay}`} {t('sidebar.log_counter.delays')}</BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Polygon5 className={sideLogAnimation?.milestone ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText>
                                    {' '}
                                    {`${logSideBar.Milestone}`} {t('sidebar.log_counter.milestones')}
                                </BottomText>
                            </Constrains>
                            <Constrains>
                                    <BottomIcon>
                                        <Ellipse50 className={sideLogAnimation?.gate ? "pulse" : ""} />
                                    </BottomIcon>
                                <BottomText> {`${logSideBar.Gate}`} {t('sidebar.log_counter.gates')}</BottomText>
                            </Constrains>
                        </BottomContainer>
                    </BottomContainerCenter>
                </SideBarContainer>
            </InnerContainer>
        </>
    );
})
